module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.selections.length > 0) ? _c('div', {
    staticClass: "pdf-zone-viewer"
  }, [_c('h2', [_vm._v("Your extraction code")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uzn),
      expression: "uzn"
    }],
    ref: "textarea",
    domProps: {
      "value": (_vm.uzn)
    },
    on: {
      "keyup": _vm.changed,
      "blur": _vm.stopEditing,
      "focus": _vm.startEditing,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.uzn = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Edit the variable names and numbers below")]), _vm._v(" and you'll see it update to the right!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("This code uses "), _c('a', {
    attrs: {
      "href": "https://github.com/jcushman/pdfquery",
      "target": "_blank"
    }
  }, [_vm._v("pdfquery")]), _vm._v(". You can just cut and paste if you want, but if you read the documentation it'll save you a lot of time.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b727782"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PDFZoneViewer.vue
// module id = 94
// module chunks = 2